<template>
  <div>
    <el-card style="min-height: 200px; padding: 20px" v-loading="loading" shadow="never">
      <div v-if="editModel && !errorMsg">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="补货门店" prop="demandStoreGuid">
            <customer-store-select
              v-model="editModel.demandStoreGuid"
              :storehouseGuid="editModel.storeGuid"
              @change="handleDemandStoreChange"
            />
          </el-form-item>
          <el-form-item label="补货方式" prop="replenishType">
            <el-radio-group v-model="editModel.replenishType">
              <el-radio label="replenish_transfer">仓库调货</el-radio>
              <el-radio label="replenish_purchase" disabled>
                仓库统采(请使用新版补货计划)
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="确认方式" prop="autoConfirm">
            <el-radio-group v-model="editModel.autoConfirm">
              <el-radio label="1">自动确认</el-radio>
              <el-radio label="0">门店确认</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="需求清单" prop="itemList">
            <div class="hBox" style="padding: 0px">
              <goods-sku-select :params="goodsSelectParams" :showCostPrice="true">
                <template slot="info-append" slot-scope="scope">
                  <div style="margin-top: 10px">
                    <template v-if="getItemBySkuGuid(scope.info.guid)">
                      <el-input
                        type="number"
                        v-model="getItemBySkuGuid(scope.info.guid).costPrice"
                        @change="handleItemGoodsChange(getItemBySkuGuid(scope.info.guid))"
                        style="width: 140px; margin-right: 10px"
                        size="small"
                        v-if="editModel.replenishType == 'replenish_purchase'"
                        placeholder="成本单价"
                        :disabled="!!getItemBySkuGuid(scope.info.guid).isDelete"
                        :min="1"
                      >
                        <template slot="prepend">成本价</template>
                      </el-input>
                      <el-input
                        type="number"
                        v-model="getItemBySkuGuid(scope.info.guid).purchasePrice"
                        @change="handleItemGoodsChange(getItemBySkuGuid(scope.info.guid))"
                        style="width: 140px; margin-right: 10px"
                        size="small"
                        placeholder="补货单价"
                        :disabled="!!getItemBySkuGuid(scope.info.guid).isDelete"
                        :min="1"
                      >
                        <template slot="prepend">补货价</template>
                      </el-input>
                      <el-input-number
                        type="number"
                        v-model="getItemBySkuGuid(scope.info.guid).purchaseCount"
                        @change="handleItemGoodsChange(getItemBySkuGuid(scope.info.guid))"
                        style="width: 120px; margin-right: 10px"
                        size="small"
                        :disabled="!!getItemBySkuGuid(scope.info.guid).isDelete"
                        :min="1"
                      >
                      </el-input-number>
                      <el-button
                        size="small"
                        type="danger"
                        v-if="!getItemBySkuGuid(scope.info.guid).guid"
                        @click="removeItemClick(getItemBySkuGuid(scope.info.guid))"
                      >
                        移出
                      </el-button>
                      <el-link
                        v-if="getItemBySkuGuid(scope.info.guid).guid"
                        :type="
                          getItemBySkuGuid(scope.info.guid).isDelete
                            ? 'primary'
                            : 'danger'
                        "
                        :underline="false"
                        @click="deleteClick(getItemBySkuGuid(scope.info.guid))"
                      >
                        {{
                          getItemBySkuGuid(scope.info.guid).isDelete
                            ? "取消删除"
                            : "标记删除"
                        }}
                      </el-link>
                    </template>
                    <template v-else>
                      <el-button
                        size="small"
                        type="primary"
                        @click="handleAddItem(scope.info)"
                      >
                        添加到清单
                      </el-button>
                    </template>
                  </div>
                </template>
              </goods-sku-select>
              <warehouse-replenish-select placeholder="从补货单中添加商品">
                <template slot="info-append" slot-scope="scope">
                  <div style="margin-top: 10px">
                    <el-button
                      size="small"
                      type="primary"
                      @click="copyReplenishItems(scope.info, scope.cancel)"
                    >
                      复制补货单商品到清单
                    </el-button>
                  </div>
                </template>
              </warehouse-replenish-select>
              <el-button @click="copyCartItems" size="small">
                从补货购物车中添加
              </el-button>
              <upload-file
                :btnLabel="batchMatchItem ? '批量添加商品' : '上传Excel文件'"
                :fileSize="10240"
                :loading="batchMatchItem"
                :fileTplUrl="'/static/file_tpl/warehouse_replenish_item_list_tpl.xls'"
                @handleUploadFile="batchMatchItemClick"
              >
              </upload-file>
            </div>
            <div>
              <el-table
                stripe
                v-if="editModel.itemList && editModel.itemList.length > 0"
                :data="editModel.itemList"
                :cell-class-name="delLine"
                :size="$xUISize"
                style="width: 100%; margin-top: 10px"
              >
                <el-table-column label="商品信息" min-width="380px">
                  <template slot-scope="scope">
                    <div style="margin-right: 10px">
                      <goods-sku-info :skuInfo="scope.row.skuInfo" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="成本单价" width="180px">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      v-model="scope.row.costPrice"
                      :disabled="
                        !!scope.row.isDelete ||
                        editModel.replenishType != 'replenish_purchase'
                      "
                      @change="handleItemGoodsChange(scope.row)"
                      placeholder="成本单价"
                      style="width: 140px"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="补货单价" width="180px">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      :disabled="!!scope.row.isDelete"
                      v-model="scope.row.purchasePrice"
                      @change="handleItemGoodsChange(scope.row)"
                      placeholder="补货单价"
                      style="width: 140px"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="补货数量" width="200px">
                  <template slot-scope="scope">
                    <el-input-number
                      :disabled="!!scope.row.isDelete"
                      v-model="scope.row.purchaseCount"
                      @change="handleItemGoodsChange(scope.row)"
                      placeholder="补货数量"
                      style="width: 140px"
                      :min="1"
                    ></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      v-if="!scope.row.guid"
                      @click="removeItemClick(scope.row)"
                    >
                      移出
                    </el-button>
                    <el-link
                      v-if="scope.row.guid"
                      :type="scope.row.isDelete ? 'primary' : 'danger'"
                      :underline="false"
                      @click="deleteClick(scope.row)"
                    >
                      {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <div
                style="color: #999999; font-size: 14px; margin-top: 20px"
                v-if="editModel.totalGoodsCount > 0"
              >
                <span>合计：共</span>
                <span style="color: #f56c6c">
                  {{ (editModel.itemList && editModel.itemList.length) || 0 }}
                </span>
                <span>种</span>
                <span>（</span>
                <span style="color: #f56c6c">
                  {{ editModel.totalGoodsCount || 0 }}
                </span>
                <span>份商品</span>
                <span>）</span>
              </div>
              <div v-else style="color: #999999; font-size: 14px; margin-top: 20px">
                * 请选择商品添加到清单
              </div>
            </div>
          </el-form-item>
          <el-form-item label="采购信息" prop="purchaseOrderRemark">
            <el-input
              type="textarea"
              v-model="editModel.purchaseOrderRemark"
              :rows="2"
              maxlength="256"
              placeholder="输入采购订单信息"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="快递单号" prop="purchaseTrackingNumber">
            <el-input
              type="textarea"
              v-model="editModel.purchaseTrackingNumber"
              :rows="2"
              maxlength="256"
              placeholder="输入快递单号"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="editModel.replenishType != 'purchase_purchase'"
            label="运费成本"
            prop="freightCost"
            key="freightCost"
          >
            <el-input
              type="number"
              @change="handleItemChange"
              v-model="editModel.freightCost"
              placeholder="请输入运费成本"
            ></el-input>
          </el-form-item>
          <el-form-item label="运费金额" prop="freightAmount" key="freightAmount">
            <el-input
              type="number"
              @change="handleItemChange"
              v-model="editModel.freightAmount"
              placeholder="请输入运费金额"
            ></el-input>
          </el-form-item>
          <el-form-item label="优惠金额" prop="discountAmount" key="discountAmount">
            <el-input
              type="number"
              @change="handleItemChange"
              v-model="editModel.discountAmount"
              placeholder="请输入优惠金额"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="3"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div style="color: #999999; font-size: 14px; margin-bottom: 10px">
              合计金额:
              <span style="font-size: 18px; color: #f56c6c">
                {{ editModel.totalAmount || 0 }}元
              </span>
            </div>
            <el-button
              type="primary"
              :loading="editSubmit"
              :disabled="
                editSubmit || !editModel.itemList || editModel.itemList.length <= 0
              "
              @click="submitClick"
            >
              提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading && errorMsg"
        :description="errorMsg"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
import uploadFile from "../../../../components/uploadFile.vue";
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import goodsSkuSelect from "../../../../components/business/goodsSkuSelect.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import warehouseReplenishSelect from "../../../../components/business/warehouseReplenishSelect.vue";

const defaultModel = {
  itemList: [],
  replenishType: "replenish_transfer",
  autoConfirm: "1",
  demandStoreGuid: "",
  freightCost: 0,
  freightAmount: 0,
  discountAmount: 0,
  totalAmount: 0,
  costAmount: 0,
};

export default {
  components: {
    uploadFile,
    goodsSkuInfo,
    goodsSkuSelect,
    customerStoreSelect,
    warehouseReplenishSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    goodsSelectParams() {
      return {
        // optSplit: 0,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      batchMatchItem: false,
      editSubmit: false,
      editModel: null,
      editRules: {
        demandStoreGuid: [
          {
            required: true,
            message: "补货门店不能为空",
            trigger: "change",
          },
        ],
        replenishType: [
          {
            required: true,
            message: "补货方式不能为空",
            trigger: "change",
          },
        ],
        autoConfirm: [
          {
            validator: (rule, value, callback) => {
              callback();
            },
            required: true,
            trigger: "change",
          },
        ],
        itemList: [
          {
            validator: (rule, value, callback) => {
              callback();
            },
            required: true,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    delLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    getItemBySkuGuid(skuGuid) {
      let findItem;
      (this.editModel.itemList || []).forEach((item) => {
        if (item.skuGuid == skuGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    batchMatchItemClick(fileData) {
      if (this.batchMatchItem) {
        return;
      }
      this.batchMatchItem = true;
      this.requestApi(
        "biz.warehouse.replenish.info.batchMatchItem",
        {
          excelBase64: fileData.data,
        },
        {
          timeout: 1000 * 60 * 60 * 24,
          showError: true,
        }
      )
        .then((resp) => {
          this.success("提交成功");
          console.log(resp);
          if (!this.editModel.itemList) {
            this.editModel.itemList = [];
          }
          (resp.data || []).forEach((iitem) => {
            let skuInfo = iitem.skuInfo;
            let flag = false;
            this.editModel.itemList.forEach((i) => {
              if (i.skuGuid == skuInfo.guid) {
                flag = true;
              }
            });
            if (!flag) {
              this.editModel.itemList.unshift({
                skuInfo: skuInfo,
                skuGuid: skuInfo.guid,
                supplierGuid: iitem.supplierGuid || "",
                costPrice: iitem.costPrice || "",
                purchasePrice: iitem.purchasePrice || "",
                purchaseCount: iitem.purchaseCount || 1,
                isDelete: 0,
              });
            }
          });
          this.handleItemChange();
          this.validate();
        })
        .finally(() => {
          this.batchMatchItem = false;
        });
    },
    handleDemandStoreChange() {
      (this.editModel.itemList || []).forEach((item) => {
        item.supplierGuid = "";
      });
    },
    handleItemGoodsChange(item) {
      if (item.purchaseCount < 0) {
        item.purchaseCount = 0;
      }
      if (item.purchasePrice < 0) {
        item.purchasePrice = 0;
      }
      if (item.costPrice < 0) {
        item.costPrice = 0;
      }
      item.totalAmount = Number(
        Number(item.purchasePrice * item.purchaseCount).toFixed(2)
      );
      item.costAmount = Number(Number(item.costPrice * item.purchaseCount).toFixed(2));
      this.handleItemChange();
    },
    handleItemChange() {
      this.editModel.costAmount = Number(this.editModel.freightCost) || 0;
      this.editModel.totalAmount =
        (Number(this.editModel.freightAmount) || 0) -
        (Number(this.editModel.discountAmount) || 0);
      (this.editModel.itemList || []).forEach((item) => {
        if (item.purchaseCount < 0) {
          item.purchaseCount = 0;
        }
        if (item.purchasePrice < 0) {
          item.purchasePrice = 0;
        }
        if (item.costPrice < 0) {
          item.costPrice = 0;
        }
        item.totalAmount = Number(
          Number(item.purchasePrice * item.purchaseCount).toFixed(2)
        );
        item.costAmount = Number(Number(item.costPrice * item.purchaseCount).toFixed(2));
        if (!item.isDelete) {
          this.editModel.totalAmount += Number(item.totalAmount);
          this.editModel.costAmount += Number(item.costAmount);
          this.editModel.totalAmount = Number(
            Number(this.editModel.totalAmount).toFixed(2)
          );
          this.editModel.costAmount = Number(
            Number(this.editModel.costAmount).toFixed(2)
          );
        }
      });
    },
    removeItemClick(row) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let indexOf = -1;
      this.editModel.itemList.forEach((i, index) => {
        if (row.skuGuid == i.skuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.editModel.itemList.splice(indexOf, 1);
      }
      this.handleItemChange();
    },
    deleteClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
      this.handleItemChange();
    },
    handleAddItem(item) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let flag = false;
      this.editModel.itemList.forEach((i) => {
        if (i.skuGuid == item.guid) {
          flag = true;
        }
      });
      if (!flag) {
        this.editModel.itemList.unshift({
          skuInfo: item,
          skuGuid: item.guid,
          supplierGuid: "",
          costPrice: "",
          purchasePrice: "",
          purchaseCount: 1,
          isDelete: 0,
        });
      }
      this.handleItemChange();
      this.validate();
    },
    checkItemList() {
      let flag = true;
      this.editModel.itemList.forEach((i) => {
        if (!i.isDelete && i.goodsCount < 0) {
          flag = false;
        }
      });
      if (!flag) {
        this.error("清单列表数量不能小于0");
      }
      return flag;
    },
    copyReplenishItems(replenishInfo, cancel) {
      this.$confirm("确定使用补货单的商品清单替换？", "确认", {
        type: "info",
      }).then(() => {
        cancel();
        this.editModel.copyGuid = replenishInfo.guid;
        this.editModel.copyStoreGuid = replenishInfo.storeGuid;
        this.fetchCopyModel();
      });
    },
    copyCartItems() {
      let storeCartData = this.readState("storeCartData", {});
      this.editModel.itemList = (storeCartData[this.editModel.demandStoreGuid] || []).map(
        (item) => {
          return {
            skuInfo: item.skuInfo,
            skuGuid: item.skuGuid,
            supplierGuid: "",
            purchaseCount: item.replenishCount || 0,
            purchasePrice: "",
            costPrice: "",
            isDelete: 0,
          };
        }
      );
      this.handleItemChange();
    },
    submitClick() {
      if (!this.checkItemList()) {
        return;
      }
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          let method = "biz.warehouse.replenish.info.createAndDemand";
          this.requestApi(method, this.editModel, {
            showError: true,
          })
            .then((resp) => {
              // 已下单的补货商品信息，从购物车种移除
              (this.editModel.itemList || []).forEach((item) => {
                this.removeCart(this.editModel.storeGuid, item.skuGuid);
              });
              this.success("提交成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.copyGuid) {
        this.editModel.copyGuid = this.pageParams.copyGuid;
      }
      if (this.pageParams.copyStoreGuid) {
        this.editModel.copyStoreGuid = this.pageParams.copyStoreGuid;
      }
      if (this.pageParams.storeGuid) {
        this.editModel.storeGuid = this.pageParams.storeGuid;
      }
      this.fetchCopyModel();
      this.handleItemChange();
    },
    fetchModel() {
      // 新增
      this.editModel = Object.assign({}, defaultModel, {
        itemList: [],
      });
      this.handleModel();
    },
    fetchCopyModel() {
      if (this.editModel.copyGuid) {
        this.loading = true;
        this.errorMsg = null;
        this.requestApi("biz.warehouse.replenish.info.detail", {
          guid: this.editModel.copyGuid,
          storeGuid: this.editModel.copyStoreGuid,
        })
          .then((resp) => {
            return this.requestApi("biz.warehouse.replenish.item.list", {
              replenishGuid: resp.data.guid,
              storeGuid: resp.data.storeGuid,
            }).then((listResp) => {
              this.editModel.freightCost = resp.data.freightCost;
              this.editModel.freightAmount = resp.data.freightAmount;
              this.editModel.discountAmount = resp.data.discountAmount;
              this.editModel.totalAmount = resp.data.totalAmount;
              this.editModel.purchaseOrderRemark = resp.data.purchaseOrderRemark;
              this.editModel.itemList = (listResp.data.list || []).map((item) => {
                return {
                  skuInfo: item.skuInfo,
                  skuGuid: item.skuGuid,
                  supplierGuid:
                    this.editModel.demandStoreGuid == this.editModel.copyStoreGuid
                      ? item.supplierGuid
                      : "",
                  purchaseCount: item.purchaseCount,
                  purchasePrice: item.purchasePrice || "",
                  costPrice: item.costPrice || "",
                  isDelete: 0,
                };
              });
              this.handleItemChange();
            });
          })
          .catch((err) => {
            let errorMessage = (err && err.msg) || (err && err.message) || "数据加载失败";
            this.$confirm(errorMessage, "重试", {
              type: "info",
            })
              .then(() => {
                this.fetchCopyModel();
              })
              .catch((_) => {
                this.$drawer.backDrawer();
              });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.copyCartItems();
      }
    },
  },
  created() {
    this.fetchModel();
  },
};
</script>
